/**
 * @author vishwadeep.kapoor
 * @see /client/containers/RestaurantsList/index.js
 * @see /client/containers/GiftCard/index.js
 * Pagination
*/

import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomIcon from 'react-fontawesome';

import PagiNation from './StyledPagination';
import { utils } from '../../devUtils';

/**
 * @default
 */
const CONFIG = {
  max_per_page: 12,
  cur_page: 1,
  min_page: 1,
  max_page: 1,
  totalRecords: 0,
};

/**
 * @param {cur_module} parent_page
 * @todo: cur_module will depend on the route config
 */
const setModularPayload = (otherProps) => {
  const { module: cur_module, defaultPayload } = otherProps;
  if (cur_module === 'restaurant') {
    const p_payload = {
      first_offset: (CONFIG.max_per_page * CONFIG.cur_page) - CONFIG.max_per_page,
    };
    return { ...defaultPayload, ...p_payload };
  } else if (cur_module === 'giftCards') {
    const p_payload = {
      page: CONFIG.cur_page,
    };
    return { ...defaultPayload, ...p_payload };
  } else if (cur_module === 'myOrders') {
    const p_payload = {
      page: CONFIG.cur_page,
    };
    return { ...defaultPayload, ...p_payload };
  } else if (cur_module === 'giftWallet') {
    const p_payload = {
      page_no: CONFIG.cur_page,
    };
    return { ...defaultPayload, ...p_payload };
  } else if (cur_module === 'eGiftCards') {
    const p_payload = {
      page: CONFIG.cur_page,
    };
    return { ...defaultPayload, ...p_payload };
  }
  return {};
};

/**
 * @param {string/number} value
 * @argument {'pre'/'next'/'Number'}
 */
const setCurPage = (value) => {
  if (value === 'pre') {
    CONFIG.cur_page -= 1;
  } else if (value === 'next') {
    CONFIG.cur_page += 1;
  } else {
    CONFIG.cur_page = value;
  }
  if (CONFIG.cur_page >= CONFIG.max_page) {
    CONFIG.cur_page = CONFIG.max_page;
  } else if (CONFIG.cur_page <= CONFIG.min_page) {
    CONFIG.cur_page = CONFIG.min_page;
  }
};

/**
 * @param {string} value
 * @param {*object} otherProps
 * @arg {otherProps:{onChange}} API hit
 */
const onClick = (value, otherProps) => {
  setCurPage(value);
  const payload = setModularPayload(otherProps);
  const { onChange } = otherProps;
  onChange(payload);
};

/**
 * @param {number} pagesMax
 * @param {*object} otherProps
 * @desc rendering UI pages
 */
const renderPages = (pagesMax, otherProps) => {
  CONFIG.max_page = pagesMax;
  const ret = [];
  const showPages = CONFIG.cur_page >= 5 ? CONFIG.cur_page : 5;
  for (let i = 1; i <= pagesMax; i += 1) {
    if (i <= showPages) {
      ret.push(
        <li onClick={() => onClick(i, otherProps)} role="presentation" key={i}>
          <span className={i === CONFIG.cur_page ? 'active' : ''}>{i}</span>
        </li>);
    }
  }
  const extended = ret.length - 5;
  ret.splice(0, extended);
  return ret;
};

const renderUItrail = (page_number, otherProps) => (<li role="presentation" onClick={() => onClick(page_number, otherProps)}><span>...</span></li>);
/**
 * @param {*number} max_per_page @desc overright the default count 12
 * @param {*number} totalRecords @desc total records of the page
 * @const {*number} isRecordUpdated validating the records are updated or not
 * @desc if pages modulus if 0 then not adding else adding 1 for decimal values;
 * @return UI
 */
function Pagination(props) {
  const { totalRecords, max_per_page, ...otherProps } = props;
  const _max_per_page = max_per_page > 0 ? max_per_page : CONFIG.max_per_page;
  const pages = totalRecords / _max_per_page;
  const addingNumber = Number.isInteger(pages) ? 0 : 1;
  const pagesMax = utils.parseInteger(pages) + addingNumber;
  const isRecordUpdated = CONFIG.totalRecords !== totalRecords && true;
  if (isRecordUpdated) {
    CONFIG.totalRecords = totalRecords;
    setCurPage(1);
  }
  return (
    <div>
      <br clear="all" />
      <PagiNation>
        <li onClick={() => onClick('pre', otherProps)} role="presentation">
          <span>
            <FontAwesomIcon name="angle-left" />
          </span>
        </li>

        {CONFIG.cur_page > 5 && renderUItrail(1, otherProps)}
        {renderPages(pagesMax, otherProps)}
        {CONFIG.cur_page !== CONFIG.max_page && renderUItrail(CONFIG.max_page, otherProps)}

        <li onClick={() => onClick('next', otherProps)} role="presentation">
          <span>
            <FontAwesomIcon name="angle-right" />
          </span>
        </li>
      </PagiNation>
      <br clear="all" />
    </div>
  );
}

Pagination.propTypes = {
  totalRecords: PropTypes.number,
  onChange: PropTypes.func,
  defaultPayload: PropTypes.object,
  module: PropTypes.string,
  max_per_page: PropTypes.number,
};

Pagination.defaultProps = {
  onChange: () => '',
  totalRecords: 0,
  max_per_page: 0,
  module: '',
  defaultPayload: {},
};
export default Pagination;



// WEBPACK FOOTER //
// client/components/Pagination/index.js